type BasePathLocation = Pick<Location, 'protocol' | 'host' | 'hostname'>;

export const getBasePath = (
  location: BasePathLocation = window.location,
  localhostBackendHostname: string | undefined = import.meta.env
    .VITE_LOCALHOST_BACKEND_HOSTNAME,
): string => {
  const { protocol, host, hostname } = location;

  if (hostname.includes('localhost')) {
    const backendHost = localhostBackendHostname || host;

    return `${protocol}//${backendHost}/`;
  }

  const normalizedHostname = hostname.includes(':')
    ? `[${hostname}]`
    : hostname;

  return `${protocol}//${normalizedHostname}/`;
};
